/* Core & libraries */
import React, { useState } from "react";
import { useTheme } from "react-jss";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";
import { Link, useNavigate } from "react-router-dom";

/* Helpers, constants, custom methods, internal libraries */
import { GUEST_DETAILS_ROUTE } from "../../../../constants/routes";
import { useUserService } from "../../../../services/userService";


/* Components */
import UCGrid from "../../../ucgrid";
import DeleteActionModal from "../../../modals/deleteActionModal";
import { ReactComponent as UserDeleteIcon } from "../../../../resources/images/user-x.svg";
import GuestNoRecords from "./guestNoRecords";
import LabelDropdown from '../../../label';

/* Styles */
import styles from "./styles.js"

const GuestGrid = (props) => {
  const { gridOptions, setGridOptions, guestProfiles, deleteGuestProfile, reloadGrid } = props;
  const theme = useTheme();
  const classes = styles({ theme });
  const navigate = useNavigate();
  const { userDetails } = useUserService();
  const [selectedRow, setSelectedRow] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const actionCallback = async (actionType, row) => {
    switch (actionType) {
      case "delete":
        setShowDeleteModal(true)
        break;
      case "edit":
        navigate( GUEST_DETAILS_ROUTE.replace(":guestId", row?.userEntityId))
        break;
    }
  }

  const deleteAction = async () => {
    const response = await deleteGuestProfile(selectedRow?.userEntityId)
    if (response) {
      setShowDeleteModal(false)
      await reloadGrid(gridOptions);
    }
  }

  return (
    <div className={classes.peopleGrid}>
      <UCGrid
        gridName="guestGrid"
        gridWrapperClassName={classes.gridWrapper}
        data={ guestProfiles?.results }
        columns={ guestProfiles?.columns }
        actions={ guestProfiles?.actions }
        handlePageChange={(page) => {setGridOptions({
          ...gridOptions,
          page
        })
        page > 1 ? navigate(`/app/guest?page=${page}`) : navigate(`/app/guest`)
        }}
        setSelectedRow={setSelectedRow}
        actionCallback={actionCallback}
        spinner="guestProfilesGridSpinner"
        customColumns={{
          fullName: (row) => (
            <Link to={`${"../../" + GUEST_DETAILS_ROUTE.replace(":guestId", row.userEntityId)}`} className={classes.link}>
              {`${row.firstName} ${row.lastName }`}
            </Link>
          ),
          label: (row) => (
            <p className={classes.role}>
              <LabelDropdown
                activeLabel={row?.labelId ? {labelId: row?.labelId, label: row?.label} : null}
                setSelectedLabelCallback={reloadGrid}
                userEntityId={row?.userEntityId}
              />
            </p>
          ),
          emailAddress: (row) => (
            row?.emailAddress || "-"
          )
        }}
        columnCustomProps={[
          {
            columnName: "label",
            allowOverflow: true,
          }
        ]}
        columnCustomWidth={{
          avatarName: "280px !important",
          roleName: "195px !important"
        }}
        disableDeleteBy={"entityID"}
        disableDeleteByValue={userDetails?.userInfo?.userEntityId}
        noDataComponent={ <GuestNoRecords /> }
        defaultSort={guestProfiles?.defaultSort}
        handleSort={(column, sortDirection) =>
          setGridOptions({
            ...gridOptions,
            sortby: column.id,
            sortdirection: sortDirection === "desc" ? "dsc" : sortDirection,
          })
        }
        onRowClickRoute={row => GUEST_DETAILS_ROUTE.replace(":guestId", row.userEntityId)}
      />

      {
        guestProfiles?.actions && guestProfiles.actions.map((action, i) => {
          switch (action) {
            case "delete":
              return <React.Fragment key={`${action}-${i}`}>
                <DeleteActionModal
                  showModal={showDeleteModal}
                  setShowModal={setShowDeleteModal}
                  setSelectedRow={setSelectedRow}
                  modalIcon={ <UserDeleteIcon /> }
                  modalTitle={ <FormattedMessage id="guest.delete.title" /> }
                  modalDescription={ <FormattedMessage id="guest.delete.description" /> }
                  submitCallback={deleteAction}
                />
            </React.Fragment>
            case "edit":
              //
          }
        })
      }
    </div>
  )
}

export default GuestGrid;
